import React, { useState, useEffect } from 'react';
import EmailForm from '../components/EmailForm';
import Quiz from '../components/Quiz';
import ThankYou from '../components/ThankYou';
import prize1 from '../assets/Nagrody-konkurs-masaz.png'; // Import the image file
import prize2 from '../assets/Nagrody-konkurs-szkolenie.png';
import regulamin from '../assets/regulamin.pdf'; // Import the regulations file

function Home() {
  const [email, setEmail] = useState(() => localStorage.getItem('userEmail') || '');
  const [quizStarted, setQuizStarted] = useState(false);
  const [quizCompleted, setQuizCompleted] = useState(false);
  const [result, setResult] = useState(null);
  const [openAnswer, setOpenAnswer] = useState('');

  useEffect(() => {
    if (email) {
      localStorage.setItem('userEmail', email);
    }
  }, [email]);

  const handleEmailSubmit = (submittedEmail) => {
    setEmail(submittedEmail);
    setQuizStarted(true);
  };

  const handleQuizComplete = (quizResult, openAnswer) => {
    setResult(quizResult);
    setOpenAnswer(openAnswer);
    setQuizCompleted(true);
  };

  const handleQuizQuit = () => {
    setEmail('');
    setQuizStarted(false);
    localStorage.removeItem('userEmail');
  };

  const handleRestart = () => {
    setEmail('');
    setQuizStarted(false);
    setQuizCompleted(false);
    setResult(null);
    localStorage.removeItem('userEmail');
  };

  return (
    <div className="app-container">
      {!email && !quizStarted && (
        <div className="welcome-container">
          <h2 className="welcome-title">OLX Praca. <strong>Poznaj lepiej specjalistów i pracowników biurowych.</strong> Odkryj perspektywę <strong>białych kołnierzyków!</strong></h2>
          <p className="welcome-text">
            Czy Polacy chętnie zmieniają pracę? Co jest obecnie <strong>najwyższą wartością dla pracowników?</strong> Czy pracownicy czują się przygotowani na zmiany związane z coraz powszechniejszym wykorzystaniem <strong>AI?</strong>
          </p>
          <p className="welcome-text">
            Odpowiedzi na te i na wiele innych pytań zawarliśmy w raporcie <strong><a href="https://zawodowo.olx.pl/wp-content/uploads/2026/04/2026_04_07_Raport-OLX-Praca-White-collars.pdf" target="_blank" rel="noreferrer">„Decyzje, które procentują. Pracownicy biurowi o realnych efektach zmiany pracodawcy”.</a></strong>
          </p>
          <p className="welcome-text">
            <strong>Już teraz sprawdź, ile wiesz na ten temat.</strong> Rozwiąż quiz, koniecznie odpowiedz na pytanie otwarte i <strong>wygraj udział w szkoleniu z cyklu Akademia Rekrutera.</strong>
          </p>
          <div className="email-form-container">

            <h3>Aby rozpocząć quiz, wprowadź swój adres e-mail:</h3>
            <EmailForm onSubmit={handleEmailSubmit} />

            {/* <h3>KONKURS ZAKOŃCZONY</h3>
 
<p>Dziękujemy za udział w konferencji Leniwce HR i za wszystkie wartościowe spotkania.</p>
<br/>
<p><strong>Wziąłeś udział w konkursie?</strong></p>

<p>Koniecznie sprawdzaj, czy wygrałeś!</p>

<p>Jury konkursowe wkrótce skontaktuje się mailowo z wybranymi osobami.</p> */}
            
          </div>
          <div className="regulations">Administratorem danych osobowych jest Grupa OLX sp. z o.o. z siedzibą w Poznaniu. Twoje dane będą przetwarzane w celu przeprowadzenia konkursu. Więcej informacji o przetwarzaniu Twoich danych osobowych, w tym o innych celach ich przetwarzania oraz przysługujących Ci prawach takich jak w szczególności prawo dostępu, poprawiania, usunięcia danych lub złożenia skargi do PUODO, znajdziesz w regulaminie konkursu pod linkiem <a href={regulamin}>Regulamin</a>.</div>
          <div className="prize-container">
            <h2 className="prize-title">Nagrody</h2>
            <div className="prize-description">
              Cenisz sobie praktyczną wiedzę z branży HR? <strong>Akademia Rekrutera jest dla Ciebie!</strong> 
            </div>
            <div className="prize-images">
              <img src={prize2} alt="Nagroda szkolenie" className="prize-image" />
            </div>
            <h2 className="prize-title">Sprawdź, o co walczysz!</h2>
            <div className="prize-description">
            Akademia Rekrutera to cykliczne warsztaty organizowane przez OLX Praca. Podczas spotkań dzielimy się swoim know-how, przedstawiamy wewnętrzne dane i pokazujemy, jak wykorzystać wiedzę w&nbsp;praktyce. W tegorocznej edycji Akademii Rekrutera odkrywamy, jak wykorzystać perspektywę kandydatów jako fundament skutecznej rekrutacji i tworzyć komunikację w pełni dopasowaną do kandydatów.
            <br/><br/><strong>Zobacz, jak wyglądała poprzednia edycja warsztatów.</strong>  

            </div>
            <div className="prize-video">
              <iframe width="100%" height="315" src="https://www.youtube.com/embed/wp8mj2pv4HU" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
            </div>
          </div>

        </div>
      )}
      {email && !quizCompleted && (
        <Quiz email={email} onComplete={handleQuizComplete} onQuit={handleQuizQuit} />
      )}
      {quizCompleted && result && <ThankYou result={result} openAnswer={openAnswer} onRestart={handleRestart} />}
    </div>
  );
}

export default Home;